import { RedisModules } from '@redis/client';
import bf from './bloom';
import cms from './count-min-sketch';
import cf from './cuckoo';
import tDigest from './t-digest';
import topK from './top-k';

export default {
  bf,
  cms,
  cf,
  tDigest,
  topK
} as const satisfies RedisModules;
